export default __webpack_public_path__ + "static/media/bash.e22f4751.svg";